import { Modal, message } from 'antd';
import type { AxiosError } from 'axios';

interface ErrorPayload {
  code?: string;
  message?: string;
  upgrade_url?: string;
}

const PLAN_LIMIT_CODES = new Set([
  'FREE_PLAN_LINK_LIMIT',
  'FREE_PLAN_RULE_LIMIT',
  'FREE_PLAN_NETWORK_LOCKED',
]);

export const handleApiError = (error: any, fallbackMessage?: string) => {
  const axiosError = error as AxiosError<ErrorPayload>;
  const response = axiosError?.response;
  const data = response?.data;
  const code = data?.code;
  const messageText = data?.message || fallbackMessage || '操作失败';

  if (code && PLAN_LIMIT_CODES.has(code)) {
    Modal.confirm({
      title: '升级套餐解锁更多功能',
      content: messageText,
      okText: '前往计费中心',
      cancelText: '稍后再说',
      centered: true,
      onOk: () => {
        const target = data?.upgrade_url || 'https://tg.me/webpage1688';
        window.location.href = target;
      },
    });
    return;
  }

  if (data?.message) {
    message.error(data.message);
    return;
  }

  if (fallbackMessage) {
    message.error(fallbackMessage);
  }
};


